// 工作室列表
const STUDIO_LIST = [
    {
        title: "工作室基本信息",
        id: "baseInfo",
    },
    {
        title: "工作室团队",
        id: "teamInfo",
    },
    {
        title: "教研情况",
        id: "teachAdd",
    },
    {
        title: "工作室资金预算",
        id: "budget",
    },
    {
        title: "工作室资金支出",
        id: "capitalExpenditure",
    },
    {
        title: "科研情况",
        id: "scientificeAdd",
    },
    {
        title: "活动方案",
        id: "activityPlanAdd",
    },
    {
        title: "标志性成果",
        id: "result",
    },
    {
        title: "思政课程与课程思政大格局",
        id: "activity",
    },
    {
        title: "团队建设",
        id: "teamBuilding",
    },
    {
        title: "思政实践基地",
        id: "practiceBase",
    },
    {
        title: "荣誉",
        id: "honor",
    },
    {
        title: "培育品牌",
        id: "brand",
    },
    {
        title: "思政微课",
        id: "szwk",
    },
]
// 品牌列表
const BRAND_LIST = [
    {
        title: "品牌基本信息",
        id: "baseInfo",
    },
    {
        title: "品牌团队",
        id: "teamInfo",
    },
    {
        title: "品牌资金预算",
        id: "budget",
    },
    {
        title: "品牌资金使用",
        id: "capitalExpenditure",
    },
    {
        title: "年度计划",
        id: "annualPlan",
    },
    {
        title: "品牌活动",
        id: "activity",
    },
    {
        title: "品牌建设",
        id: "brandBuilding",
    },
    {
        title: "思政育人",
        id: "educatingPeople",
    },
    {
        title: "品牌成果",
        id: "achievement",
    },
    // {
    //   title: "品牌荣誉",
    //   id: "honor",
    // },
    {
        title: "品牌宣传",
        id: "brandPropaganda",
    },
    {
        title: "品牌效果",
        id: "result",
    },
    // {
    //   title: "品牌基地",
    //   id: "practiceBase",
    // },
]
export {
    STUDIO_LIST,
    BRAND_LIST,
}
